import { addendumSlice } from './addendum.slice';

export const ADDENDUM_REDUCER_KEY = addendumSlice.name;
export const addendumReducer = addendumSlice.reducer;
